import TechSpecModal from './TechSpecModal.vue'

export default TechSpecModal
